const state = {
  emailSettings: {
    notification_period: null,
    sender: null,
    mail_server: null,
  },
};
const requestURL = `/restapi/mail`;

const getters = {
  currentEmailSettings(state) {
    return state.emailSettings;
  },
};

const actions = {
  async getEmailSetting({ commit }, { mspId = null }) {
    const response = await this._vm.$http.get(
      mspId !== null ? requestURL + `?msp_id=${mspId}` : requestURL
    );
    commit("setEmailSettings", response.data);
  },

  async updateEmailSetting({ commit }, { settings, mspId = null }) {
    const response = await this._vm.$http.post(
      mspId !== null ? requestURL + `?msp_id=${mspId}` : requestURL,
      settings
    );
    commit("setEmailSettings", response.data);
  },
};

const mutations = {
  setEmailSettings(state, data) {
    (state.emailSettings.notification_period = data.notification_period),
      (state.emailSettings.sender = data.sender),
      (state.emailSettings.mail_server = data.server);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
